const dialogCommonConfig = {
    width: 'calc(100% - 1rem)',
    margin: '1rem',
    autoFocus: false,
    panelClass: ['ui-dialog']
};

export const dialogConfig = {
    ...dialogCommonConfig,
    maxWidth: '400px',
};

export const dialogMdConfig = {
    ...dialogCommonConfig,
    maxWidth: '600px',
};

export const dialogLgConfig = {
    ...dialogCommonConfig,
    maxWidth: '1000px',
};

export const sidenavCommonDialogConfig = {
    width: 'calc(100% - 1.5rem)',
    autoFocus: false,
    height: '100%',
    position: {top: '0px', right:'0px'},
    panelClass: ['ui-drawer', 'slide-in-end']
};

export const sidenavDialogConfig = {
    ...sidenavCommonDialogConfig,
    maxWidth: '450px',
};

export const sidenavMdDialogConfig = {
    ...sidenavCommonDialogConfig,
    maxWidth: '700px',
};

export const fullscreenDialogConfig = {
    width: '100vw',
    maxWidth: '100vw',
    height: '100vh',
    autoFocus: false,
    panelClass: ['ui-dialog', 'fullscreen-dialog'],
};